import { title } from "process";

export const emailcontacts = [
  {
      title: "Energy Champion",
      name: "Richard Nerysoo",
      email: "energychampion@dinjiizhuhsolutions.com" ,
      link: "mailto:energychampion@dinjiizhuhsolutions.com"
  },
  {
    title: "Energy Coordinator",
      name: "Trina Nerysoo",
      email: "energycoordinator@dinjiizhuhsolutions.com",
      link: "mailto:energycoordinator@dinjiizhuhsolutions.com"
  },
  {
    title: "Energy Liaison Worker",
      name: "Roberta Alexie",
      email: "energyliaison@dinjiizhuhsolutions.com",
      link: "mailto:Energyliaison@dinjiizhuhsolutions.com"
  },
  {
    title: "Finance officer",
    name: "Denise Robert",
    email: "finance@dinjiizhuhsolutions.com",
    link: "mailto:Finance@dinjiizhuhsolutions.com"
  },
];